import React, { useContext, useEffect, useMemo, useState } from "react";
import { LangContext } from "../../context/lang-context";

import FormSkel from "./FormSkel";
import { NotificationManager } from "react-notifications";

export default ({
  terminalData,
  machines,
  handleSubmit,
  handleClose,
  handleAddMachine,
  abbr,
  customers,
  canEditConsoleFields = false,
}) => {
  const { TRL_Pack } = useContext(LangContext);

  const getCheckboxValue = (value, defaultValue = false) => {
    if (value === null || value === undefined) return defaultValue;

    return (
      value === true ||
      value === 1 ||
      value === "1" ||
      String(value).toLowerCase() === "true"
    );
  };

  const [customer, setCustomer] = useState(
    terminalData
      ? `${terminalData.CustomerName} (${terminalData.Abbreviation})`
      : ""
  );

  const [useTrxForSales, setUseTrxForSales] = useState(false);
  const [useVMCTrx, setUseVMCTrx] = useState(false);
  const [useGenerateMachine, setUseGenerateMachine] = useState(false);
  const [isCustomerSIM, setIsCustomerSIM] = useState(
    getCheckboxValue(terminalData?.IsCustomerSIM, false)
  );
  const [isForTests, setIsForTests] = useState(
    getCheckboxValue(terminalData?.IsForTests, false)
  );
  const [isForRent, setIsForRent] = useState(
    getCheckboxValue(terminalData?.IsForRent, false)
  );
  const [rentalPrice, setRentalPrice] = useState(
    terminalData?.RentalPrice ?? ""
  );
  const [deleteTransactions, setDeleteTransactions] = useState(false);

  const hasAssignedMachine = Boolean(terminalData?.MachineId);

  useEffect(() => {
    if (!terminalData) return;
    const shouldUseDefaultValues =
      !terminalData.MachineId && !terminalData.MachineFullName;
    const nextUseTrxForSales = getCheckboxValue(
      terminalData.UseTrxForSales,
      shouldUseDefaultValues
    );
    const nextUseVMCTrx = getCheckboxValue(terminalData.UseVMCTrx, false);
    const nextUseGenerateMachine = getCheckboxValue(
      terminalData.UseGenerateMachine,
      shouldUseDefaultValues
    );

    setUseTrxForSales(nextUseTrxForSales);
    setUseVMCTrx(nextUseVMCTrx);
    setUseGenerateMachine(nextUseGenerateMachine);
    setIsCustomerSIM(getCheckboxValue(terminalData.IsCustomerSIM, false));
    setIsForTests(getCheckboxValue(terminalData.IsForTests, false));
    setIsForRent(getCheckboxValue(terminalData.IsForRent, false));
    setRentalPrice(terminalData.RentalPrice ?? "");
    setDeleteTransactions(false);
  }, [terminalData]);

  const terminals = ["Vendotek", "PAX", "NAYAX", "Newland", "NEXGO"];

  const handleChangeMachine = (evt) => {
    const value = evt.target.value;

    const machine = machines.find(
      (obj) =>
        obj.Name === value ||
        obj.MachineName === value ||
        obj.MachineFullName === value ||
        obj.SerialNo === value ||
        obj.MachineSerialNo === value
    );

    if (terminalData) {
      terminalData.MachineId = machine?.MachineId || null;
    }
  };

  const filterMachines = (value) => {
    const selectedCustomer =
      customers &&
      customers.find(
        (customerEntry) =>
          `${customerEntry.Name} (${customerEntry.Abbreviation})` === value
      );

    return selectedCustomer
      ? machines.filter(
          (machine) =>
            machine.Abbreviation === selectedCustomer.Abbreviation
        )
      : [];
  };

  const memoFilterMachines = useMemo(
    () => filterMachines(customer),
    [customer, machines, customers]
  );

  const handleFocusMachine = (evt) => {
    evt.target.select();
  };

  const handleChangeUseTrxForSales = (evt) => {
    const checked = evt.target.checked;

    setUseTrxForSales(checked);

    if (terminalData) {
      terminalData.UseTrxForSales = checked;
    }
  };

  const handleChangeUseVMCTrx = (evt) => {
    const checked = evt.target.checked;

    setUseVMCTrx(checked);

    if (terminalData) {
      terminalData.UseVMCTrx = checked;
    }
  };

  const handleChangeUseGenerateMachine = (evt) => {
    const checked = evt.target.checked;

    setUseGenerateMachine(checked);

    if (terminalData) {
      terminalData.UseGenerateMachine = checked;
    }
  };

  const handleChangeIsCustomerSIM = (evt) => {
    const checked = evt.target.checked;

    setIsCustomerSIM(checked);

    if (terminalData) {
      terminalData.IsCustomerSIM = checked;
    }
  };

  const handleChangeIsForRent = (evt) => {
    const checked = evt.target.checked;

    setIsForRent(checked);

    if (!checked) {
      setRentalPrice("");
    }

    if (terminalData) {
      terminalData.IsForRent = checked;
      if (!checked) terminalData.RentalPrice = null;
    }
  };

  const handleChangeRentalPrice = (evt) => {
    const value = evt.target.value;

    setRentalPrice(value);

    if (terminalData) {
      terminalData.RentalPrice = value === "" ? null : Number(value);
    }
  };

  const handleChangeIsForTests = (evt) => {
    const checked = evt.target.checked;

    setIsForTests(checked);

    if (terminalData) {
      terminalData.IsForTests = checked;
    }
  };

  const handleClickAddMachine = () => {
    if (typeof handleAddMachine !== "function") {
      NotificationManager.error(
        "Brak funkcji otwierającej formularz dodawania automatu."
      );
      return;
    }

    handleAddMachine(terminalData);
  };

  return (
    <FormSkel
      headerText={terminalData ? "Ustawienia" : "Nowy terminal"}
      handleClose={handleClose}
      data={terminalData ? { IsActive: true } : null}
      btnWords={{ deactivate: "Usuń" }}
    >
      <form onSubmit={handleSubmit} id="modal-form" autoComplete="off">
        {terminalData && (
          <>
            <div className="form-group">
              {sessionStorage.getItem("clientId") === "console" && (
                <>
                  <label className="h6 primary align-middle m-1">Klient</label>

                  <input
                    type="text"
                    autoComplete="off"
                    form="modal-form"
                    list="usersLookup"
                    className="mt-2 form-control form-control-sm"
                    name="clientName"
                    value={customer}
                    onChange={(evt) => setCustomer(evt.target.value)}
                  />

                  <datalist id="usersLookup">
                    {customers &&
                      customers.map((user) => (
                        <option
                          value={`${user.Name} (${user.Abbreviation})`}
                          key={user.CustomerId || user.Abbreviation}
                        />
                      ))}
                  </datalist>
                </>
              )}

              <label className="h6 primary align-middle m-1">Automat</label>

              <input
                onFocus={handleFocusMachine}
                className="mt-2 form-control form-control-sm"
                placeholder="Szukaj"
                onChange={handleChangeMachine}
                name="machine"
                defaultValue={terminalData?.MachineFullName}
                list="machinesLookup"
                autoComplete="off"
              />

              <datalist id="machinesLookup">
                {(sessionStorage.getItem("clientId") === "console"
                  ? memoFilterMachines
                  : machines
                ).map((entry) => (
                  <option
                    value={entry.Name}
                    key={
                      entry.MachineId ||
                      entry.SerialNo ||
                      entry.MachineSerialNo
                    }
                  />
                ))}
              </datalist>

              {!hasAssignedMachine && (
                <button
                  type="button"
                  className="btn btn-primary mt-2"
                  onClick={handleClickAddMachine}
                >
                  Dodaj automat
                </button>
              )}
            </div>

            <div>
              <div className="d-flex flex-column">
                <div className="d-inline-block flex-row form-check mb-10px">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="useTrxForSales"
                    onChange={handleChangeUseTrxForSales}
                    checked={useTrxForSales}
                  />

                  <label className="h6">
                    Rozliczanie sprzedaży przez Transakcje
                  </label>
                </div>

                <div className="d-inline-block flex-row form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="useVMCTrx"
                    onChange={handleChangeUseVMCTrx}
                    checked={useVMCTrx}
                  />

                  <label className="h6">
                    Rozliczanie sprzedaży przez Transakcje z płyty głównej R24
                    VMC
                  </label>
                </div>

                <div className="d-inline-block flex-row form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="useGenerateMachine"
                    onChange={handleChangeUseGenerateMachine}
                    checked={useGenerateMachine}
                  />

                  <label className="h6">
                    Automatyczna konfiguracja automatu na podstawie transakcji
                  </label>
                </div>

                {canEditConsoleFields && (
                  <div className="d-flex flex-column">
                    <div
                      className="d-flex flex-row align-items-center form-check"
                      style={{ minHeight: "36px" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="isCustomerSIM"
                        onChange={handleChangeIsCustomerSIM}
                        checked={isCustomerSIM}
                      />

                      <label className="h6 mb-0">Karta SIM klienta</label>
                    </div>

                    <div className="mt-2 mb-2">
                      <label className="h6 mb-1 ml-1 d-block">Karta SIM Data</label>
                      <input
                        type="datetime-local"
                        name="simDateTime"
                        className="form-control form-control-sm"
                        defaultValue={terminalData?.SimDateTime || ""}
                      />
                    </div>

                    <div
                      className="d-flex flex-row align-items-center form-check"
                      style={{ minHeight: "36px" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="isForTests"
                        onChange={handleChangeIsForTests}
                        checked={isForTests}
                      />

                      <label className="h6 mb-0">Na testy</label>
                    </div>

                    <div
                      className="d-flex flex-row align-items-center form-check"
                      style={{ minHeight: "36px" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="isForRent"
                        onChange={handleChangeIsForRent}
                        checked={isForRent}
                      />

                      <label className="h6 mb-0">Na wynajem</label>

                      <input
                        type="number"
                        name="rentalPrice"
                        className="form-control form-control-sm ml-2"
                        style={{ width: "110px" }}
                        min="0"
                        step="0.01"
                        placeholder="Cena najmu"
                        value={rentalPrice}
                        onChange={handleChangeRentalPrice}
                        disabled={!isForRent}
                        required={isForRent}
                      />
                    </div>
                  </div>
                )}

                {sessionStorage.getItem("clientId") === "console" && (
                  <div className="d-inline-block flex-row form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="deleteTransactions"
                      onChange={(evt) => setDeleteTransactions(evt.target.checked)}
                      checked={deleteTransactions}
                    />

                    <label className="h6">Usuń transakcje</label>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {!terminalData && (
          <div className="form-group">
            <label className="h6 primary align-middle m-1">Klient</label>

            <input
              type="text"
              autoComplete="off"
              form="modal-form"
              list="usersLookup"
              className="mt-2 form-control form-control-sm"
              name="clientName"
            />

            <datalist id="usersLookup">
              {customers &&
                customers.map((user) => (
                  <option
                    value={`${user.Name} (${user.Abbreviation})`}
                    key={user.CustomerId || user.Abbreviation}
                  />
                ))}
            </datalist>

            <label className="h6 primary align-middle m-1">
              Typ terminala
            </label>

            <input
              type="text"
              autoComplete="off"
              form="modal-form"
              list="terminalTypeList"
              className="mt-2 form-control form-control-sm"
              name="terminalType"
            />

            <datalist id="terminalTypeList">
              {terminals.map((terminalType) => (
                <option value={terminalType} key={terminalType} />
              ))}
            </datalist>

            <label className="h6 primary align-middle m-1">
              Numer seryjny
            </label>

            <input
              type="text"
              className="mt-2 form-control form-control-sm"
              form="modal-form"
              autoComplete="off"
              minLength={4}
              maxLength={12}
              name="serialNo"
              onKeyDown={(evt) => {
                if (
                  evt.target.value.length >= 12 &&
                  evt.key.length === 1 &&
                  !evt.ctrlKey &&
                  !evt.metaKey
                ) {
                  NotificationManager.error(
                    "Nazwa numeru seryjnego nie może przekraczać 12 znaków."
                  );
                }
              }}
            />

            {canEditConsoleFields && (
              <div className="d-flex flex-column mt-3">
                <div
                  className="d-flex flex-row align-items-center form-check"
                  style={{ minHeight: "36px" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="isCustomerSIM"
                    onChange={handleChangeIsCustomerSIM}
                    checked={isCustomerSIM}
                  />

                  <label className="h6 mb-0">Karta SIM klienta</label>
                </div>

                    <div className="mt-2 mb-2">
                      <label className="h6 ml-1 mb-1 d-block">Karta SIM Data</label>
                      <input
                        type="datetime-local"
                        name="simDateTime"
                        className="form-control form-control-sm"
                        defaultValue=""
                      />
                    </div>

                <div
                  className="d-flex flex-row align-items-center form-check"
                  style={{ minHeight: "36px" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="isForTests"
                    onChange={handleChangeIsForTests}
                    checked={isForTests}
                  />

                  <label className="h6 mb-0">Na testy</label>
                </div>

                <div
                  className="d-flex flex-row align-items-center form-check"
                  style={{ minHeight: "36px" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="isForRent"
                    onChange={handleChangeIsForRent}
                    checked={isForRent}
                  />

                  <label className="h6 mb-0">Na wynajem</label>

                  <input
                    type="number"
                    name="rentalPrice"
                    className="form-control form-control-sm ml-2"
                    style={{ width: "110px" }}
                    min="0"
                    step="0.01"
                    placeholder="Cena najmu"
                    value={rentalPrice}
                    onChange={handleChangeRentalPrice}
                    disabled={!isForRent}
                    required={isForRent}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </form>
    </FormSkel>
  );
};